import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pb-2 z-20",
  style: {"min-height":"max-content"}
}
const _hoisted_2 = { class: "flex flex-row gap-4 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultipleSelectPillSearch = _resolveComponent("MultipleSelectPillSearch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MultipleSelectPillSearch, {
        "filter-label": _ctx.$t('dashboard.breakdownFilter.service'),
        "preserve-order": "",
        "filter-icon": require('@/app/ui/assets/svg/ics_o_services.svg'),
        "filter-icon-active": 
          require('@/app/ui/assets/svg/ics_o_services_active.svg')
        ,
        options: _ctx.serviceTypeOptions,
        selected: _ctx.activeBreakdownFilters.serviceTypes,
        searchable: false,
        "use-infinite-scroll": false,
        "is-loading": false,
        "on-change": _ctx.handleServiceTypeChange,
        showSearchInput: false
      }, null, 8, ["filter-label", "filter-icon", "filter-icon-active", "options", "selected", "on-change"]),
      _createVNode(_component_MultipleSelectPillSearch, {
        "filter-label": _ctx.$t('dashboard.breakdownFilter.channel'),
        "filter-icon": require('@/app/ui/assets/svg/ics_o_pos.svg'),
        "filter-icon-active": 
          require('@/app/ui/assets/svg/ics_o_pos_active.svg')
        ,
        options: _ctx.channelOptions,
        selected: _ctx.activeBreakdownFilters.channels,
        searchable: false,
        "use-infinite-scroll": false,
        "is-loading": false,
        "on-change": _ctx.handleChannelChange,
        showSearchInput: false
      }, null, 8, ["filter-label", "filter-icon", "filter-icon-active", "options", "selected", "on-change"]),
      _createVNode(_component_MultipleSelectPillSearch, {
        ref: "productTypeFilter",
        "filter-label": _ctx.$t('dashboard.breakdownFilter.productType'),
        "filter-icon": require('@/app/ui/assets/svg/ics_o_shipping_service.svg'),
        "filter-icon-active": 
          require('@/app/ui/assets/svg/ics_o_shipping_service_active.svg')
        ,
        options: _ctx.productTypeOptionsMapped,
        selected: _ctx.activeBreakdownFilters.productTypes,
        searchable: true,
        "use-infinite-scroll": true,
        "is-loading": _ctx.isLoadingProductTypes,
        "on-scroll": _ctx.handleProductScroll,
        "on-search": _ctx.handleProductTypeSearch,
        "on-change": _ctx.handleProductTypeChange
      }, null, 8, ["filter-label", "filter-icon", "filter-icon-active", "options", "selected", "is-loading", "on-scroll", "on-search", "on-change"]),
      _createVNode(_component_MultipleSelectPillSearch, {
        ref: "destinationCities",
        "filter-label": _ctx.$t('dashboard.breakdownFilter.destinationCity'),
        "filter-icon": require('@/app/ui/assets/svg/ics_o_destination.svg'),
        "filter-icon-active": 
          require('@/app/ui/assets/svg/ics_o_destination_active.svg')
        ,
        options: _ctx.destinationCityOptionsMapped,
        selected: _ctx.activeBreakdownFilters.destinationCities,
        searchable: true,
        "use-infinite-scroll": true,
        "is-loading": _ctx.isLoadingDestinationCities,
        "on-search": _ctx.handleDestinationCitySearch,
        "on-scroll": _ctx.handleDestinationCityScroll,
        "on-change": _ctx.handleDestinationCityChange
      }, null, 8, ["filter-label", "filter-icon", "filter-icon-active", "options", "selected", "is-loading", "on-search", "on-scroll", "on-change"]),
      _createVNode(_component_MultipleSelectPillSearch, {
        ref: "commodityFilter",
        "filter-label": _ctx.$t('dashboard.breakdownFilter.commodity'),
        "filter-icon": require('@/app/ui/assets/svg/ics_o_commodity_v2.svg'),
        "filter-icon-active": 
          require('@/app/ui/assets/svg/ics_o_commodity_v2_active.svg')
        ,
        options: _ctx.commodityOptionsMapped,
        selected: _ctx.activeBreakdownFilters.commodities,
        searchable: true,
        "use-infinite-scroll": true,
        "is-loading": _ctx.isLoadingCommodities,
        "on-search": _ctx.handleCommoditySearch,
        "on-scroll": _ctx.handleCommodityScroll,
        "on-change": _ctx.handleCommodityChange
      }, null, 8, ["filter-label", "filter-icon", "filter-icon-active", "options", "selected", "is-loading", "on-search", "on-scroll", "on-change"])
    ])
  ]))
}